"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _EventDetail = _interopRequireDefault(require("@rsuite/icon-font/lib/time/EventDetail"));

// Generated by script, don't edit it please.
var EventDetail = (0, _createSvgIcon["default"])({
  as: _EventDetail["default"],
  ariaLabel: 'event detail',
  category: 'time',
  displayName: 'EventDetail'
});
var _default = EventDetail;
exports["default"] = _default;
module.exports = exports.default;